// oxlint-disable-next-line no-restricted-imports
import { Group, UnstyledButton } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";

import { colors } from "#app/theme/v2/colors";
import { Divider } from "#components/atoms/Divider/Divider";
import { Text } from "#components/atoms/Typographies/Text";

import { DropdownMenu } from "../DropdownMenu/DropdownMenu";
import classes from "./UnitSelect.module.css";

type UnitSelectProps = {
  unit: string;
  units: string[];
  onUnitChange: (unit: string) => void;
  disabled?: boolean;
  error?: boolean;
};

const UnitSelect = ({ unit, units, onUnitChange, disabled, error }: UnitSelectProps) => {
  const textColor = disabled ? colors.text.primaryDisabled : colors.text.primaryDefault;
  const iconColor = disabled ? colors.icon.primaryDisabled : colors.icon.primaryDefault;
  const dividerColor = error ? colors.border.error.primary : colors.border.secondaryDefault;

  return (
    <Group gap={0} wrap="nowrap" align="stretch" h="100%">
      <Divider orientation="vertical" color={dividerColor} style={{ alignSelf: "stretch" }} />
      <DropdownMenu>
        <DropdownMenu.Target>
          <UnstyledButton
            type="button"
            disabled={disabled}
            aria-label="Select unit"
            className={classes.button}
            style={{ cursor: disabled ? "not-allowed" : "pointer" }}
          >
            <Text size="small" type="regular" color={textColor}>
              {unit}
            </Text>
            <IconChevronDown size={12} color={iconColor} />
          </UnstyledButton>
        </DropdownMenu.Target>
        <DropdownMenu.Dropdown>
          {units.map((u) => (
            <DropdownMenu.Item key={u} onClick={() => onUnitChange(u)}>
              {u}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Dropdown>
      </DropdownMenu>
    </Group>
  );
};

export { UnitSelect };
